export const UserMessage = () => {
  return (
    <div className="m-2 ml-auto mt-2 flex w-full max-w-xs justify-end space-x-3">
      <div className="text-end ">
        <div className=" rounded-l-lg rounded-br-lg bg-blue-600 p-3 text-start  text-white">
          <p className="text-xs">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod.
          </p>
        </div>
        <span className="pr-2 text-[10px] leading-none text-gray-500">
          2 min ago
        </span>
      </div>
    </div>
  );
};
